var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricingImag3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 94,
    viewBox: "0 0 105 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.5 18.5255C46.8182 8.23358 39.0909 0 26.8182 0C14.5455 0 0 11.4355 0 27.4453C0 43.455 10.9091 71.5864 52.5 94C94.0909 71.5864 105 43.455 105 27.4453C105 11.4355 90.4546 0 78.1818 0C65.9091 0 58.1818 8.23358 52.5 18.5255Z",
    fill: "#FF6360"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingImag3);
export default __webpack_public_path__ + "static/media/pricing-imag3.70087e55fe28454f6bfc6227e61318a5.svg";
export { ForwardRef as ReactComponent };